/**
 * Public pricing page — Free / Professional / Enterprise cards (Phase 11).
 */
import { Alert, Box, Stack, Typography } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import { Link as RouterLink } from "react-router-dom";
import { Button } from "@mui/material";

import { PlanTierCards } from "../features/pricing/PlanTierCards";
import { GlassSurface } from "../layouts/components/GlassSurface";
import { usePageHeader } from "../layouts/PageHeaderContext";

export function PricingPage() {
	usePageHeader({
		title: "Pricing",
		subtitle: "Choose the plan that matches your soil-intelligence workflow",
		breadcrumbs: [{ label: "Home", to: "/" }, { label: "Pricing" }],
	});

	return (
		<Box sx={{ maxWidth: 1100, mx: "auto" }} data-testid="pricing-page">
			<Alert severity="info" sx={{ mb: 3 }} variant="outlined">
				Free accounts must verify email before creating tests. Professional is
				activated only after payment confirmation (Stripe). Enterprise is
				provisioned by Flaha after contract agreement.
			</Alert>

			<PlanTierCards />

			<GlassSurface intensity="subtle" depth="flat" sx={{ p: 2.5, mt: 3 }}>
				<Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
					<LockIcon sx={{ color: "workspace.textMuted" }} fontSize="small" />
					<Typography variant="subtitle1" fontWeight={700}>
						Locked features stay visible
					</Typography>
				</Stack>
				<Typography variant="body2" sx={{ color: "workspace.textSecondary", mb: 1.5 }}>
					In the soil-test wizard, Moderate and Advanced levels appear with an
					upgrade explanation when your plan does not include them. The API
					rejects prohibited levels even if a client bypasses the UI.
				</Typography>
				<Button component={RouterLink} to="/enterprise/contact" size="small">
					Ask about Enterprise
				</Button>
			</GlassSurface>
		</Box>
	);
}
